/****************************************************************************************************
* error -> page-error
****************************************************************************************************/



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let errorIsSnippet = true;
// if(errorIsSnippet && typeof errorIsRevert !== 'undefined') errorScrollClear();



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let errorSel = '.page-error .sector.hero ';


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let errorShowTl; // eslint-disable-line no-unused-vars


////////////////////////////////////////////////// Init
const errorInit = (gsapRef, errorTitle) => {
  gsapRef.set(`${errorSel} .contents-wrapper`, {opacity: 0});
  
  gsapRef.set(`${errorSel} .sector-copy.title`, {opacity: 0, innerHTML: ""});
  
  gsapRef.set(`${errorSel} .sector-copy.sentence`, {opacity: 0, y:' -50%'});
  
  gsapRef.set(`.sector.hero .button-container`, {opacity: 0, scaleY:'0.5'});
  gsapRef.set(`.sector.hero .button-copy`, {opacity: 0});
}


////////////////////////////////////////////////// Scroll
const errorScrollMake = (gsapRef, scrollTriggerRef, smootherRef, errorTitle) => {

  ////////////////////////////// Error show
  errorShowTl = gsapRef.timeline({
    // onStart: () => {},
    // onComplete: () => {},
    // onReverseComplete: () => {}
  })
  .addLabel('t0', 0)
    
  .to(`${errorSel} .contents-wrapper`, {duration: 0.4, opacity: 1, ease: 'power1.out'})
  .to(`${errorSel} .sector-copy.title`, {duration: 0.3, opacity: 1, ease: 'power1.out' }, 't0+=1')
  .to(`${errorSel} .sector-copy.title`, {duration: 2,
    scrambleText: {text: errorTitle, chars: "ABCDEFGHIJKLMNOPQRSTUVWXYZ", 
     revealDelay: 0.5, speed: 1, newClass: "scramble"}
  }, 't0+=1')
    
  .addLabel('t1', '-=1')
    
  .to(`${errorSel} .sector-copy.sentence`, {duration: 0.5, opacity: 1, y: '0%', ease: 'power1.out'}, 't1')

  .addLabel('t2', 't1+=0.2')
    
  .to(`.sector.hero .button-container`, {duration: 0.2, opacity: 1, ease: 'power1.out'},'t2')
  .to(`.sector.hero .button-container`, {duration: 0.3, scaleY:'1', ease: 'power1.out'}, 't2')
  .to(`.sector.hero .button-copy`, {duration: 0.4, opacity: 1, ease: 'power1.inOut'}, 't2+=0.1')
  ;
}


////////////////////////////////////////////////// Scroll: clear
const errorScrollClear = () => {
  if(errorShowTl) { errorShowTl.revert(); errorShowTl = null; }
}


////////////////////////////////////////////////// Code for snippet
// if(errorIsSnippet) {
//   errorInit(gsapRef);
//   errorScrollMake(gsapRef, scrollTrigger, smootherRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const errorElsControl = (opt='play') => {
  if(opt === 'play') {
    document.querySelectorAll('.shape').forEach(el => el.unpauseAnimations());
  } else {
    document.querySelectorAll('.shape').forEach(el => el.pauseAnimations());
  }
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing
const errorResizeStart = (gsapRef, scrollTriggerRef, smootherRef) => {
  console.log("[error] Resize: START");
}

const errorResizeDone = (gsapRef, scrollTriggerRef, smootherRef, errorTitle) => {
  console.log("[error] Resize: END");

  errorScrollClear();
  errorInit(gsapRef, errorTitle);
  errorScrollMake(gsapRef, scrollTriggerRef, smootherRef, errorTitle);
}

////////// Code for snippet
// let errorResizing = false;
// const errorResizeHandle = (e) => {
//   if(!errorResizing) {
//     errorResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     errorResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     errorResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     errorResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef, draggableRef);
//   }, 1000, 'errorResize');
// }
// if(errorIsSnippet) {
//   if(typeof errorIsRevert !== 'undefined') window.removeEventListener('resize', errorResizeHandleRef);
//   window.errorResizeHandleRef = errorResizeHandle;
//   window.addEventListener('resize', errorResizeHandleRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key
////////////////////////////////////////////////// Play / Pause Elements animation
const errorControlKey = (key) => {
  if(!document.querySelector(".page-error")) return;

  let opt = document.querySelectorAll('.page-error .shape')[0].animationsPaused() ? 'play' : 'pause';
  errorElsControl(opt);
  console.log(`[error: control] [key: ${key} pressed] Elements animation: ${opt}`);
};

////////////////////////////////////////////////// Code for snippet
// const errorControlKeyHandler = (e) => { if(e.key === '0') errorControlKey(e.key); }
// if(errorIsSnippet) {
//  if(typeof errorIsRevert !== 'undefined') window.removeEventListener('keydown', errorControlKeyHandlerRef);
//   window.errorControlKeyHandlerRef = errorControlKeyHandler;
//   window.addEventListener('keydown', errorControlKeyHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(errorIsSnippet) var errorIsRevert = true;



//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  errorInit,
  errorScrollMake,
  errorScrollClear,
  // errorElsControl,
  errorResizeStart,
  errorResizeDone,
  errorControlKey
}